import { FBCallToAction } from '@marketing-milk/interfaces'

/**
 * Title-case a Facebook call-to-action enum value for display on the local
 * preview's CTA button, e.g. `APPLY_NOW` -> "Apply Now". The Creative Wizard's
 * `CALL_TO_ACTION_OPTIONS` renders the raw uppercased value ("APPLY NOW") and
 * filters out a set of options, so it isn't reusable here — this is the small,
 * dedicated label formatter the FB feed mock needs.
 */
export function formatCallToAction(cta: FBCallToAction | string): string {
  return cta
    .split('_')
    .map(word => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(' ')
}
